/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

const createReportModelMixin = (reportModelExecute, dashboardReportNavigation) => {
    return {
        execute() {
            var self = this;
            return reportModelExecute.apply(this, arguments).then(function (response) {
                dashboardReportNavigation.addDashboardReport(self.execution.urlRun() + '/' + response.requestId);
            });
        }
    }
};

export default createReportModelMixin;

